import { render, staticRenderFns } from "./oplahjeniskiriman_list.vue?vue&type=template&id=6597a99a"
import script from "./oplahjeniskiriman_list.vue?vue&type=script&lang=js"
export * from "./oplahjeniskiriman_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports